import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {Text} from '../../atoms/Text/Text';
import {BuyTicketTopInfoProps} from './BuyTicketTopInfoProps.interface';

export function BuyTicketTopInfo({
  seriesTitle,
  cash,
  ...props
}: BuyTicketTopInfoProps) {
  return (
    <div {...props}>
      <Text className="font-small2-bold text-theme-solid-100">
        {seriesTitle}
      </Text>
      <div className="mt-8pxr flex justify-between">
        <Text className="font-small1 text-theme-solid-60">
          {t('common_cash_balance')}
        </Text>
        <Text className="font-small1-bold text-theme-solid-100">
          {t('common_cash_amount', {
            values: {
              value: formatWithCommas(cash),
            },
          })}
        </Text>
      </div>
    </div>
  );
}
